import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ConfigService } from './auth/config.service'; // Assuming you have a ConfigService for the base URL
import { Router } from '@angular/router';



@Injectable({
  providedIn: 'root',
})
export class AuditService {
  constructor(private http: HttpClient, private configService: ConfigService, private router: Router) { }

  // Method to fetch all auditors based on optional filters

  getAllAuditors(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Audit/GetAll`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Retrieved Data failed.'));
      })
    );
  }
  // Method to get auditor details
  getAuditorDetails(id: number): Observable<any[]> {

    const apiUrl = `${this.configService.getApiUrl()}/Audit/GetAuditor/${id}`;

    return this.http.get<any[]>(apiUrl);
  }

  // Method for Add auditor 

  addAuditor(newAuditor: any): Observable<any> {

    const apiUrl = `${this.configService.getApiUrl()}/Audit/Add`;

    return this.http.post<any>(apiUrl, newAuditor).pipe(
      map((response) => response),
      catchError((err) => {
        console.error(err);
        return throwError(() => new Error('Something went wrong while adding the auditor.'));
      })
    );
  }

    assignAuditDate(data:any): Observable<any> {

    const apiUrl = `${this.configService.getApiUrl()}/Admin/AssignAuditDate`;

    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => response),
      catchError((err) => {
        console.error(err);
        return throwError(() => new Error('Something went wrong.'));
      })
    );
  }
  GetTransId(iSocietyDetailID: number, actionName: string,iSocietyDetailsTranID: number,iAllotAuditorID:number): Observable<any> {
    const apiUrl = `${this.configService.getApiUrl()}/CheckList/SocietyDetailsTransSET`;

    // Create request body
    const requestBody = {
      iSocietyDetailID: iSocietyDetailID,
      actionName: actionName,
      iSocietyDetailTranID:iSocietyDetailsTranID,
      iAllotAuditorID:iAllotAuditorID
    };

    return this.http.post<any>(apiUrl, requestBody).pipe(
      catchError((error) => {
        console.error("API Error:", error);
        return throwError(() => new Error('Something went wrong while fetching transaction details.'));
      })
    );
  }

  // Function to call the backend API
  getDropDownValues(): Observable<any> {
    const apiUrl = `${this.configService.getApiUrl()}/Audit/GetDropDown`;

    return this.http.get<any>(apiUrl);
  }


  // Method to update an auditor
  updateAudit(audit: any, id: number): Observable<any> {
    const url = `${this.configService.getApiUrl()}/Audit/Update/${id}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http.put(url, audit, { headers }).pipe(
      map(response => response),
      catchError((error) => {
        console.error('Error updating audit:', error);
        throw error;
      })
    );
  }

  // Method for Delete auditor 
  deleteAudit(id: number): Observable<any> {
    const url = `${this.configService.getApiUrl()}/Audit/Delete/${id}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http.post(url, { headers }).pipe(
      catchError((error) => {
        console.error('Error deleting audit:', error);
        throw error;
      })
    );
  }

  // Method to get auditor details
  getSocietyDetails(iSocietyDetailsId: number): Observable<any[]> {

    const apiUrl = `${this.configService.getApiUrl()}/CheckList/GetSociety/${iSocietyDetailsId}`;

    return this.http.get<any[]>(apiUrl);
  }
  // Service method to call the GetAllEmployeeDetails API
  getAllEmployeeDetails(iSocietyDetailsId: any): Observable<any> {

    const apiUrl = `${this.configService.getApiUrl()}/CheckList/GetAll/${iSocietyDetailsId}`;

    return this.http.get<any>(apiUrl, iSocietyDetailsId).pipe(
      map((response) => {
        return response;
      }),
      catchError((error) => {
        return throwError(() => new Error('Failed to retrieve employee details.'));
      })
    );
  }

  // Service method to call the GetAllEmployeeDetails API
  getAllBorrowerDetails(iSocietyDetailsID: any): Observable<any> {

    const apiUrl = `${this.configService.getApiUrl()}/CheckList/GetListBorrowerDetails/${iSocietyDetailsID}`;

    return this.http.get<any>(apiUrl, iSocietyDetailsID).pipe(
      map((response) => {
        return response;
      }),
      catchError((error) => {
        return throwError(() => new Error('Failed to retrieve employee details.'));
      })
    );
  }
  // Service method to call the GetAllEmployeeDetails API
  getAllBalanceDetails(iSocietyDetailID: any): Observable<any> {

    const apiUrl = `${this.configService.getApiUrl()}/CheckList/GetBalanceSheet/${iSocietyDetailID}`;

    return this.http.get<any>(apiUrl, iSocietyDetailID).pipe(
      map((response) => {
        return response;
      }),
      catchError((error) => {
        return throwError(() => new Error('Failed to retrieve employee details.'));
      })
    );
  }
  // Service method to call the GetAllEmployeeDetails API
  getEmployeeDetails(): Observable<any> {
    const apiUrl = `${this.configService.getApiUrl()}/CheckList/GetEmployees`;  // Your API endpoint

    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;  // Return the API response as it is
      }),
      catchError((error) => {
        return throwError(() => new Error('Failed to retrieve employee details.'));
      })
    );
  }

  // Service method to call the GetAllBalance API
  getBalanceDetails(iSocietyDetailsId: number): Observable<any> {
    const apiUrl = `${this.configService.getApiUrl()}/CheckList/GetBalanceSheetData/${iSocietyDetailsId}`;

    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((error) => {
        return throwError(() => new Error('Failed to retrieve employee details.'));
      })
    );
  }
  // Service method to call the GetAllBalance API
  getBorrowerDetails(iSocietyDetailsId: number): Observable<any> {
    const apiUrl = `${this.configService.getApiUrl()}/CheckList/GetListBorrowerDetails/${iSocietyDetailsId}`;

    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((error) => {
        return throwError(() => new Error('Failed to retrieve employee details.'));
      })
    );
  }
  // Method for Add EMployee 

  addEmployee(newEMP: any): Observable<any> {

    const apiUrl = `${this.configService.getApiUrl()}/CheckList/Add`;
    return this.http.post<any>(apiUrl, newEMP).pipe(
      map((response) => response),
      catchError((err) => {
        console.error(err);
        return throwError(() => new Error('Something went wrong while adding the employee.'));
      })
    );
  }


  // Method for Add EMployee 

  StatusUpdat(status: any, iSocietyDetailsId: number): Observable<any> {

    const apiUrl = `${this.configService.getApiUrl()}/FinalChecklist/UpdateStatus/${iSocietyDetailsId}`;
    return this.http.post<any>(apiUrl, status).pipe(
      map((response) => response),
      catchError((err) => {
        console.error(err);
        return throwError(() => new Error('Something went wrong while adding the employee.'));
      })
    );
  }
  // Method for Add Borrower 

  addBorrower(borrower: any): Observable<any> {

    const apiUrl = `${this.configService.getApiUrl()}/CheckList/SocietyBorrowerDetails`;
    return this.http.post<any>(apiUrl, borrower).pipe(
      map((response) => response),
      catchError((err) => {
        console.error(err);
        return throwError(() => new Error('Something went wrong while adding the Borrower.'));
      })
    );
  }
  // Method for Add Balance 

  addBalance(newBalance: any): Observable<any> {

    const apiUrl = `${this.configService.getApiUrl()}/CheckList/AddBalanceSheetData`;
    return this.http.post<any>(apiUrl, newBalance).pipe(
      map((response) => response),
      catchError((err) => {
        console.error(err);
        return throwError(() => new Error('Something went wrong while adding the balance.'));
      })
    );
  }
  // Method for Delete emp 
  deleteEmployee(iTSocietyEmpID: number): Observable<any> {
    const url = `${this.configService.getApiUrl()}/CheckList/Delete/${iTSocietyEmpID}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http.delete(url, { headers }).pipe(
      catchError((error) => {
        console.error('Error deleting employee:', error);
        throw error;
      })
    );
  }

  // Method for Delete balance 
deleteBalance(balanceSheetID: number): Observable<any> {
  const url = `${this.configService.getApiUrl()}/FinalChecklist/DeleteBalance`;
  const headers = new HttpHeaders().set('Content-Type', 'application/json');

  const payload = {
    BalanceSheetID: balanceSheetID
  };

  return this.http.post(url, payload, { headers }).pipe(
    catchError((error) => {
      console.error('Error deleting Balance:', error);
      throw error;
    })
  );
}

  // Method for Delete borrower 
  deleteBorrower(iSocietyBorrowerDetails: number): Observable<any> {
    const url = `${this.configService.getApiUrl()}/CheckList/DeleteBorrower/${iSocietyBorrowerDetails}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http.delete(url, { headers }).pipe(
      catchError((error) => {
        console.error('Error deleting Service:', error);
        throw error;
      })
    );
  }
  // Method for Add Comman Society 

  addCommanSociety(newSociety: any): Observable<any> {

    const apiUrl = `${this.configService.getApiUrl()}/CheckList/Add/CommanSociety`;
    return this.http.post<any>(apiUrl, newSociety).pipe(
      map((response) => response),
      catchError((err) => {
        return throwError(() => new Error('Something went wrong while adding the auditor.'));
      })
    );
  }

  // Method for Add Comman Society 

  addBuilding(building: any): Observable<any> {

    const apiUrl = `${this.configService.getApiUrl()}/CheckList/SetSocietyDetailFields`;
    return this.http.post<any>(apiUrl, building).pipe(
      map((response) => response),
      catchError((err) => {
        return throwError(() => new Error('Something went wrong while adding the auditor.'));
      })
    );
  }
  // Method for Add Coprate Society 

  addAuditPera(newAuditPera: any): Observable<any> {

    const apiUrl = `${this.configService.getApiUrl()}/CheckList/SetAuditParameter`;
    return this.http.post<any>(apiUrl, newAuditPera).pipe(
      map((response) => response),
      catchError((err) => {
        return throwError(() => new Error('Something went wrong while adding the coprate Society.'));
      })
    );
  }
  // Method for Add Coprate Society 

  addCoprateSociety(newcoprateSocity: any): Observable<any> {

    const apiUrl = `${this.configService.getApiUrl()}/CheckList/SocietyCreditCooperativeSET`;
    return this.http.post<any>(apiUrl, newcoprateSocity).pipe(
      map((response) => response),
      catchError((err) => {
        return throwError(() => new Error('Something went wrong while adding the coprate Society.'));
      })
    );
  }
  // Service method to call the GetAllEmployeeDetails API
  getCommanDatas(): Observable<any> {
    const apiUrl = `${this.configService.getApiUrl()}/CheckList/GetCommandata`;  // Your API endpoint

    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;  // Return the API response as it is
      }),
      catchError((error) => {
        return throwError(() => new Error('Failed to retrieve employee details.'));
      })
    );
  }

  // Method for Add Society Business 


  addSocietyBusiness(newchecked: any): Observable<any> {

    const apiUrl = `${this.configService.getApiUrl()}/CheckList/AddServiceTurnover`;

    return this.http.post<any>(apiUrl, newchecked).pipe(
      map((response) => response),
      catchError((error) => {
        console.error('Error while adding society business:', error);
        return throwError(() => new Error('Something went wrong while adding the Society Business.'));
      })
    );
  }




  // Method for Add NON-Credit data
  addNonCredit(newnonCredit: any): Observable<any> {

    const apiUrl = `${this.configService.getApiUrl()}/CheckList/AddNonCredit`;
    return this.http.post<any>(apiUrl, newnonCredit).pipe(
      map((response) => response),
      catchError((err) => {
        return throwError(() => new Error('Something went wrong while adding the Non-Credit Data.'));
      })
    );
  }
  // Method to update the society remarks
  updateSocietyRemark(remark: any): Observable<any> {

    const apiUrl = `${this.configService.getApiUrl()}/CheckList/UpdateRemark`;
    return this.http.post<any>(apiUrl, remark).pipe(
      map((response) => response),
      catchError((err) => {
        return throwError(() => new Error('Something went wrong while Updating Remarks.'));
      })
    );
  }

  // updateDepartmentalRemark(data: any): Observable<any> {
  //   return this.http.post<any>(`${this.apiUrl}/UpdateDepartmentalRemark`, data).pipe(
  //     map((response) => response),
  //     catchError((err) => {
  //       return throwError(() => new Error('Something went wrong while updating remarks.'));
  //     })
  //   );
  // }

addAuditComment(data: any): Observable<any> {

    const apiUrl = `${this.configService.getApiUrl()}/FinalChecklist/AddAuditComments`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => response),
      catchError((err) => {
        return throwError(() => new Error('Something went wrong while Updating Remarks and Status'));
      })
    );

}

  updateDepartmentalRemark(data: any): Observable<any> {

    const apiUrl = `${this.configService.getApiUrl()}/FinalChecklist/UpdateDepartmentalRemark`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => response),
      catchError((err) => {
        return throwError(() => new Error('Something went wrong while Updating Remarks.'));
      })
    );
  }

auditSentBack(data: any): Observable<any> {
  const apiUrl = `${this.configService.getApiUrl()}/FinalChecklist/AuditSentBack`;
  return this.http.post<any>(apiUrl, data).pipe(
    map((response) => response),
    catchError((err) => {
      console.error(err);
      return throwError(() => new Error('Something went wrong while updating remarks.'));
    })
  );
}

auditMoveForward(data: any): Observable<any> {
  const apiUrl = `${this.configService.getApiUrl()}/FinalChecklist/MoveForwardToVerifier`;
  return this.http.post<any>(apiUrl, data).pipe(
    map((response) => response),
    catchError((err) => {
      console.error(err);
      return throwError(() => new Error('Something went wrong while updating remarks.'));
    })
  );
}

  updateDepartmentalStatus(data: any): Observable<any> {

    const apiUrl = `${this.configService.getApiUrl()}/FinalChecklist/UpdateSendStatusToAR`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => response),
      catchError((err) => {
        return throwError(() => new Error('Something went wrong while Updating Remarks.'));
      })
    );
  }
  paymentConfirm(payment: any): Observable<any> {
    const apiUrl = `${this.configService.getApiUrl()}/Audit/PaymentConfirmByAuditor`;
    return this.http.post<any>(apiUrl, payment).pipe(
      map((response) => response),
      catchError((err) => {
        return throwError(() => new Error('Something went wrong while Updating Remarks.'));
      })
    );
  }
  updateRemark(remark: any): Observable<any> {
    const apiUrl = `${this.configService.getApiUrl()}/CheckList/SaveRemarktoFwdApplication`;
    return this.http.post<any>(apiUrl, remark).pipe(
      map((response) => response),
      catchError((err) => {
        return throwError(() => new Error('Something went wrong while Updating Remarks.'));
      })
    );
  }
  addCommonParameter(commonParameter: any): Observable<any> {

    const apiUrl = `${this.configService.getApiUrl()}/CheckList/AuditBasicCommonParameter`;
    return this.http.post<any>(apiUrl, commonParameter).pipe(
      map((response) => response),
      catchError((err) => {
        return throwError(() => new Error('Something went wrong while adding the common parameter.'));
      })
    );
  }


  Getassignedaudit(data: any): Observable<any> {

    const url = `${this.configService.getApiUrl()}/Audit/GetAssignesAuditList`;
    return this.http.post<any>(url, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Retrieved Data failed.'));
      })
    );
  }
  GetSocietyDetails(id: any): Observable<any> {
    const url = `${this.configService.getApiUrl()}/Audit/GetSocityDetails/${id}`;
    return this.http.get<any>(url).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Retrieved Data failed.'));

      })
    );
  }




  // Assistant Registrar work
  getSocietyDetail(iSocietyDetailsId: number): Observable<any> {
    const apiUrl = `${this.configService.getApiUrl()}/CheckList/GetSociety/${iSocietyDetailsId}`;

    return this.http.get<any>(apiUrl);
  }

  // Assistant Registrar work
  getMemberDetail(requestParams: any): Observable<any> {
    const apiUrl = `${this.configService.getApiUrl()}/Audit/GetMemberDetails`;
    return this.http.post<any>(apiUrl, requestParams);
  }
  // Assistant Registrar work
  getFiltersData(): Observable<any> {
    const apiUrl = `${this.configService.getApiUrl()}/Audit/GetFiltersData`;
    return this.http.get<any>(apiUrl);
  }
  // Assistant Registrar work
  getAssignedDropDownValues(): Observable<any> {
    const apiUrl = `${this.configService.getApiUrl()}/Audit/GetAssignedDropDownData`;
    return this.http.get<any>(apiUrl);
  }

  bindDistrict(iDistrictID: number): Observable<any> {

    const apiUrl = `${this.configService.getApiUrl()}/CheckList/GetMasterDropdown?iDistrictID=${iDistrictID}`;
    return this.http.get<any>(apiUrl);
  }

  getAssignedDropDown(id: number): Observable<any> {
    const apiUrl = `${this.configService.getApiUrl()}/Audit/GetAssignedDropDownData/${id}`;
    return this.http.get<any>(apiUrl);
  }

  // getAuditedSocieties(id:number,data:any): Observable<any> {
  //   const apiUrl = `${this.configService.getApiUrl()}/Audit/GetAuditedSocieties/${id}`; 
  //   return this.http.get<any>(apiUrl); 
  // }

  getAuditedSocieties(data: any): Observable<any> {

    const apiUrl = `${this.configService.getApiUrl()}/Audit/GetAuditedSocieties`;
    return this.http.post<any>(apiUrl, data); // Send data in the request body
  }


  getSocietyAndAuditorDetails(id: number): Observable<any> {
    const apiUrl = `${this.configService.getApiUrl()}/Audit/GetSocietyAndAuditorDetail/${id}`;
    return this.http.get<any>(apiUrl);
  }


  addMember(newAuditor: any): Observable<any> {
    const apiUrl = `${this.configService.getApiUrl()}/Audit/AddMember`;
      return this.http.post<any>(apiUrl, newAuditor).pipe(
      map((response) => response),
      catchError((err) => {
        console.error('Error:', err);
        return throwError(() => new Error('Something went wrong while adding the auditor.'));
      })
    )
  }

  getSocietyVerificationDetails(SocietyDetailsID: number): Observable<any> {
    const apiUrl = `${this.configService.getApiUrl()}/FinalChecklist/GetSocietyVerificationList/${SocietyDetailsID}`;
    return this.http.get<any>(apiUrl);
  }

  bindDesignation(): Observable<any> {
    const apiUrl = `${this.configService.getApiUrl()}/Audit/BindDesignationDropdown`;
    return this.http.get<any>(apiUrl);
  }

  bindOfficer(id: number,SocietyDetailsID:any): Observable<any> {
    const apiUrl = `${this.configService.getApiUrl()}/Audit/BindOfficerDropdown/${id}/${SocietyDetailsID}`;
    return this.http.get<any>(apiUrl);
  }

  getAuditOfficerDetail(id: number): Observable<any> {
    const apiUrl = `${this.configService.getApiUrl()}/Audit/GetAuditOfficerDetail/${id}`;
    return this.http.get<any>(apiUrl);
  }

  assignVerifier(data: any): Observable<any> {
    const apiUrl = `${this.configService.getApiUrl()}/Audit/AssignVerifier`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    });

    return this.http.post<any>(apiUrl, JSON.stringify(data), { headers }).pipe(
      map((response) => response),
      catchError((err) => {
        console.error('Error:', err);
        return throwError(() => new Error(err.error?.message || 'Something went wrong while adding the auditor.'));
      })
    );
  }

  updateAuditStatus(societydetailsid: number, action: string, id: number): Observable<any> {
    const apiUrl = `${this.configService.getApiUrl()}/Audit/UpdateAuditStatus?societydetailsid=${societydetailsid}&action=${action}&id=${id}`;


    return this.http.post<any>(apiUrl, {});
  }

  // updateAuditStatus(isocietydetailsid:number,action:string): Observable<any> {
  //   const apiUrl = `${this.configService.getApiUrl()}/Testing/UpdateAuditStatus/${id}`; 
  //   return this.http.post<any>(apiUrl); 
  // }
  // updateAuditStatus(data: any): Observable<any> {
  //   const apiUrl = `${this.configService.getApiUrl()}/Testing/UpdateAuditStatus`;
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     'Accept': 'application/json'
  //   });

  //   return this.http.post<any>(apiUrl, JSON.stringify(data), { headers }).pipe(
  //     map((response) => response),
  //     catchError((err) => {
  //       console.error('Error:', err);
  //       return throwError(() => new Error(err.error?.message || 'Something went wrong while adding the auditor.'));
  //     })
  //   );
  // }

  getAssignedVerifierDetails(): Observable<any> {
    const apiUrl = `${this.configService.getApiUrl()}/Audit/GetAssignedVerifierDetails`;
    return this.http.get<any>(apiUrl);
  }

  getSocietyListForAuditVerification(postData: any): Observable<any> {
    const apiUrl = `${this.configService.getApiUrl()}/Audit/GetSocitiesListForAuditVerification`;
    return this.http.post<any>(apiUrl, postData);
  }
}
